import { useCallback, useMemo } from 'react';

export enum PinScreenSetting {
  manually = 'manually',
  afterInactivePeriod = 'afterInactivePeriod',
  afterEachSale = 'afterEachSale',
}

export const usePinScreenSetting = () => {
  const getPinScreenSetting = useCallback(() => {
    const storedSetting = localStorage.getItem('pin_screen_setting');

    if (!storedSetting) {
      return { setting: PinScreenSetting.manually, metadata: undefined, showPinScreenOnStartup: false };
    }

    const parsed = JSON.parse(storedSetting);
    const setting = parsed.setting
      ? PinScreenSetting[parsed.setting as keyof typeof PinScreenSetting]
      : PinScreenSetting.manually;
    const metadata: string | undefined = parsed.metadata ? JSON.parse(parsed.metadata) : undefined;
    const showPinScreenOnStartup: boolean = parsed.showPinScreenOnStartup ?? false;
    return { setting: setting, metadata: metadata, showPinScreenOnStartup: showPinScreenOnStartup };
  }, []);

  const setPinScreenSetting = useCallback(
    (setting: PinScreenSetting, metadata: string | undefined, showPinScreenOnStartup: boolean) => {
      const value = { setting: setting, metadata: metadata, showPinScreenOnStartup: showPinScreenOnStartup };
      localStorage.setItem('pin_screen_setting', JSON.stringify(value));
    },
    []
  );

  return useMemo(() => ({ getPinScreenSetting, setPinScreenSetting }), [getPinScreenSetting, setPinScreenSetting]);
};
